import type {ComponentProps} from 'react'

import {DotcomLayoutRuntime} from '../dotcom-layout-runtime'
import {
  CollapsibleNavList as CoreNavList,
  CollapsibleNavListLinkItem as CoreLinkItem,
  type CollapsibleNavListLinkItemProps,
} from '@github-ui/layout-primitives-core'

export {
  CollapsibleNavListGroup,
  CollapsibleNavListGroupHeading,
  CollapsibleNavListTrailingAction,
  type CollapsibleNavListLinkItemProps,
  type CollapsibleNavListGroupPopoverMaxHeight,
  type CollapsibleNavListGroupPopoverMaxWidth,
  type CollapsibleNavListGroupPopoverWidth,
  type CollapsibleNavListGroupPopoverSize,
  type CollapsibleNavListGroupSection,
  type CollapsibleNavListGroupProps,
  type CollapsibleNavListGroupHeadingProps,
  type CollapsibleNavListTrailingActionProps,
  type CollapsibleNavListItemProps,
} from '@github-ui/layout-primitives-core'

function Root(props: ComponentProps<typeof CoreNavList>) {
  return (
    <DotcomLayoutRuntime>
      <CoreNavList {...props} />
    </DotcomLayoutRuntime>
  )
}

export function CollapsibleNavListLinkItem(props: CollapsibleNavListLinkItemProps) {
  return (
    <DotcomLayoutRuntime>
      <CoreLinkItem {...props} />
    </DotcomLayoutRuntime>
  )
}

Root.displayName = 'CollapsibleNavList'
export const CollapsibleNavList = Object.assign(Root, {...CoreNavList}, {LinkItem: CollapsibleNavListLinkItem})
export {Root as CollapsibleNavListRoot}
